<template>
  <div id="paibantablewrap">
    <table id="paibantable">
      <thead>
        <tr>
          <td
            :style="{ width: x.width ? x.width + 'px' : '' }"
            v-for="(x, index) in columns"
            :key="index"
          >
            <h4>{{ x.title }}</h4>
            {{ x.day }}
          </td>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(y, index1) in tableData" :key="index1">
          <td
            :style="{ width: x.width ? x.width + 'px' : '' }"
            v-for="(x, index) in columns"
            :key="index"
          >
            <template v-if="index == 0">
              <Input v-model="y[x.key]" style="width: 150px"></Input>
            </template>
            <template v-else>
              <template>
                <selectUser
                  :name="y[x.key] ? y[x.key].name : ''"
                  @user="reUser($event, x.key, index1)"
                  @clear="clear(x.key, index1)"
                  style="width: 60px"
                  clearable
                >
                </selectUser>
              </template>
            </template>
          </td>
        </tr>
      </tbody>
    </table>
    <Button @click="charu">新增类目</Button>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tableData: [],
      columns: [],
      dayList: [],
      start: "",
      end: "",
    };
  },
  methods: {
    reach(v, isAdd) {
      console.log(321,v);
      this.dayList = v;
      if (isAdd) {
        this.tableData = [
          { itemName: "全线日常保洁、洗扫" },
          { itemName: "全线日常巡查" },
          { itemName: "夜巡视" },
          { itemName: "清洗全线伸缩缝" },
          { itemName: "清理疏通全线排水沟、泄水孔" },
          { itemName: "清理疏通积水点" },
          { itemName: "清洗标志标牌、防撞墙、水马等交安附属设施" },
          { itemName: "全线绿化浇水" },
          { itemName: "全线绿化除草、修剪、杀虫" },
          { itemName: "全线绿化施肥" },
          { itemName: "路面洒水清洗" },
        ];
      } else {
        this.aToB();
      }
    },
    changeTime(v) {
      this.start = v.startDate;
      this.end = v.endDate;
      this.creartTime();
    },
    creartTime() {
      var aa = this.end - this.start;
      var start = this.start;
      var maxDate = Math.ceil(aa / 86400000); //最后一天
      this.columns = [{ title: "项目名称", key: "itemName" }];
      var day = ["日", "一", "二", "三", "四", "五", "六"];
      for (let i = 1; i <= maxDate; i++) {
        var cdate = new Date(start);
        var obj = {
          key: start,
          title: i,
          day: day[cdate.getDay()],
          cdate: start,
        };
        this.columns.push(obj);
        start += 86400000;
      }
    },
    bToA() {
      var t = this.tableData;
      var c = this.columns;
      var m = [];
      for (let j = 0; j < c.length; j++) {
        var user = [];
        for (let i = 0; i < t.length; i++) {
          //console.log(t[i][c[j].cdate]);
          if (t[i][c[j].cdate]) {
            var obj = {
              name: t[i][c[j].cdate].name,
              account: t[i][c[j].cdate].account,
              accountId: t[i][c[j].cdate].accountId,
              itemName: t[i].itemName,
            };
            user.push(obj);
          }

          if (i == t.length - 1) {
            var k = {
              cdate: c[j].cdate,
              numTimes: ["18:00"],
              user: user,
            };
            m.push(k);
          }
        }
      }
      m.splice(0, 1);

      return m;
    },
    aToB() {
      this.tableData=[];
      var d = this.dayList;
      var m = [];
      var itemNameArr = []; //临时数组，用来判断作业项目是否存在用
      var columns = [{ title: "作业项目", key: "itemName" }];
      var day = ["日", "一", "二", "三", "四", "五", "六"];
      for (let i = 0; i < d.length; i++) {
        var cdate = new Date(d[i].cdate);
        var cobj = {
          title: cdate.getDate(),
          key: d[i].cdate,
          day: day[cdate.getDay()],
          cdate: cdate.getTime(),
        };
        columns.push(cobj);
        var user = d[i].user;
        for (let j = 0; j < user.length; j++) {
          var obj = {};
          obj[d[i]["cdate"]] = user[j];
          //寻找到人员对应的作业项目
          var itemName = d[i].user[j].itemName;
          obj.itemName = itemName;
          var index = itemNameArr.indexOf(itemName);
          if (index == -1) {
            //如果作业项目不存在，则添加作业项目
            itemNameArr.push(itemName);
            m.push(obj);
          } else {
            //如果作业项目存在，则找到项目位置，将日期对象附上
            m[index][d[i]["cdate"]] = user[j];
          }
        }
      }

      this.tableData = m;
      this.columns = columns;
      //this.$set(this.columns, 0, columns);
    },
    reUser(v, key, index) {
      var aaa = {
        name: v.name,
        account: v.account,
        accountId: v.accountId,
      };
      this.$set(this.tableData[index], key, aaa);
      /* this.tableData[index][key] = {
        name:v.name,
        account:v.account,
        actions:v.accountId
      }; */
    },
    clear(key, index) {
      //删除user属性
      delete this.tableData[index][key];
    },
    charu(){
      this.tableData.push({itemName:'项目名称'})
    }
  },
  mounted() {
    //this.creartTime();
  },
};
</script>
<style>
#paibantablewrap {
  width: 100%;
  overflow: auto;
}
#paibantable h4 {
  font-weight: bold;
  font-size: 18px;
}

#paibantable {
  padding: 10px;
  margin-bottom: 20px;
  border: solid #086486;
  border-width: 2px 0;
  min-width: 1600px;
  max-width: 1920px;
}

#paibantable td {
  padding: 4px;
  text-align: center;
}
#paibantable td:first-child {
  padding: 4px;
  text-align: left;
}
</style>


// WEBPACK FOOTER //
// src/components/yhgl/renyuanpaibanTime.vue